import React from "react";
import { Input } from "reactstrap";
import { formatPriceWithDollar } from "../utils/currency";

const DollarInput = ({
  value,
  onChange,
  onBlur,
  onFocus,
  name,
  placeholder = "$0.00",
  disabled = false,
  className = "",
  style = {},
  /** When true, parent onChange runs on every keystroke (raw numeric string) so validation can track typing; blur still sends formatted value. */
  updateWhileTyping = false,
  ...rest
}) => {
  const [isFocused, setIsFocused] = React.useState(false);
  const [internalValue, setInternalValue] = React.useState(value || '');

  // Sync internal value with external value
  React.useEffect(() => {
    setInternalValue(value || '');
  }, [value]);

  const handleFocus = (e) => {
    setIsFocused(true);

    const raw = internalValue?.toString().replace(/[^\d.\-]/g, '') || '';

    // Clear input if value is 0 or 0.00 to allow easy typing
    if (parseFloat(raw) === 0) {
      setInternalValue('');
    }

    if (onFocus) {
      onFocus(e, raw);
    }
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    const formatted = formatPriceWithDollar(internalValue);
    setInternalValue(formatted);

    if (onBlur) {
      onBlur(e, formatted);
    }

    // Call onChange with formatted value only on blur
    if (onChange) {
      onChange(formatted);
    }
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Sadece sayı, nokta ve negatif işareti kabul et
    const cleanedValue = inputValue.replace(/[^\d.\-]/g, '');
    setInternalValue(cleanedValue);

    if (updateWhileTyping && onChange) {
      onChange(cleanedValue);
    }
  };

  const displayValue = isFocused
    ? internalValue?.toString().replace(/[^\d.\-]/g, '') || ''
    : formatPriceWithDollar(internalValue);

  return (
    <Input
      type="text"
      name={name}
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      style={{ textAlign: 'right', ...style }}
      {...rest}
    />
  );
};

export default DollarInput;

